export default ({ request }) => ({
  pendingOrderListApi(data = {}) {
    return request({
      url: '/factory/pending/order/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsListApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/list',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsSelectImagesApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/selectImages',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/spec/list',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/spec/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandFabricListApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/fabric/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandFabricDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/fabric/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderTechDocListApi(data = {}) {
    return request({
      url: '/factory/pending/order/tech/doc/list',
      method: 'post',
      data,
    })
  },
  pendingOrderTechDocSpecListApi(data = {}) {
    return request({
      url: '/factory/pending/order/tech/doc/spec/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandMaterialListApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/material/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandMaterialDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/material/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsPackageSizeListApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/package/size/list',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsPackageSizeDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/package/size/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsPackageDocListApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/package/doc/list',
      method: 'post',
      data,
    })
  },
  pendingOrderGoodsPackageDocGoodsListApi(data = {}) {
    return request({
      url: '/factory/pending/order/goods/package/doc/goods/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandPackageListApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/package/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandPackageDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/package/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandPackingListApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/packing/list',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandPackingDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/packing/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderDemandPackingGoodsListApi(data = {}) {
    return request({
      url: '/factory/pending/order/demand/packing/goods/list',
      method: 'post',
      data,
    })
  },
  pendingOrderProofingListApi(data = {}) {
    return request({
      url: '/factory/pending/order/proofing/list',
      method: 'post',
      data,
    })
  },
  pendingOrderProofingDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/proofing/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderProofingGoodsListApi(data = {}) {
    return request({
      url: '/factory/pending/order/proofing/goods/list',
      method: 'post',
      data,
    })
  },
  pendingOrderBatchListApi(data = {}) {
    return request({
      url: '/factory/pending/order/batch/list',
      method: 'post',
      data,
    })
  },
  pendingOrderBatchDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/batch/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderBatchGoodsListApi(data = {}) {
    return request({
      url: '/factory/pending/order/batch/goods/list',
      method: 'post',
      data,
    })
  },
  pendingOrderInspectionListApi(data = {}) {
    return request({
      url: '/factory/pending/order/inspection/list',
      method: 'post',
      data,
    })
  },
  pendingOrderInspectionDetailApi(data = {}) {
    return request({
      url: '/factory/pending/order/inspection/detail',
      method: 'post',
      data,
    })
  },
  pendingOrderInspectionBatchListApi(data = {}) {
    return request({
      url: '/factory/pending/order/inspection/batch/list',
      method: 'post',
      data,
    })
  },
  pendingOrderInspectionDocListApi(data = {}) {
    return request({
      url: '/factory/pending/order/inspection/doc/list',
      method: 'post',
      data,
    })
  },
  pendingOrderInspectionDocBatchListApi(data = {}) {
    return request({
      url: '/factory/pending/order/inspection/doc/batch/list',
      method: 'post',
      data,
    })
  },
  pendingOrderExecutionLogListApi(data = {}) {
    return request({
      url: '/factory/pending/order/execution/log/list',
      method: 'post',
      data,
    })
  },
})
